import react from 'react'
import dotzBg from './../../../images/dotzBg.jpg'


const Third_Pane = () => (

    <div className='uk-margin-large-top '>

        <div className='uk-container'>
          <div className='thirdCurved'>

        <div class="uk-child-width-1-3@s uk-grid uk-text-center" data-uk-grid>
                        <div>
                            <div class=" uk-padding-small">
                                <h1 className='uk-text-bold uk-text-left' uk-scrollspy="cls: uk-animation-slide-left; repeat: true">We Create Smart Architecture.</h1>
                            </div>
                        </div>
              <div>

                            <div className=''>
                                <h6 class="uk-text-small uk-text-bold uk-text-left uk-padding-small" 
                                uk-scrollspy="cls: uk-animation-slide-top; repeat: true">Far far away, behind the
                                 word mountains, far from the  countries Vokalia and Consonantia, 
                                   there live the blind texts</h6>


                            
                        <div class="uk-flex uk-margin-small-top">
                                <div class="">
                                    <h1 className='header1 blueText' uk-scrollspy="cls: uk-animation-slide-bottom; repeat: true">25</h1>
                                    <h6 className='uk-text-small uk-text-bold uk-margin-remove-top '>Years of experience</h6>
                                </div>

                                <div class="uk-margin-left">
                                    <h1 className='header1 blueText' uk-scrollspy="cls: uk-animation-slide-top; repeat: true">56</h1>
                                    <h6 className='uk-text-small uk-text-bold uk-margin-remove-top '>Project build</h6>
                                </div>

                                <div class="uk-margin-left" >
                                    <h1 className='header1 blueText' uk-scrollspy="cls: uk-animation-slide-bottom; repeat: true">98</h1>
                                    <h6 className='uk-text-small uk-text-bold uk-margin-remove-top '>Satisfied Clients</h6>
                                </div>
                     </div>
                   </div>
 </div>
  <div>
                            <div class="uk-margin-left uk-margin-remove-top">
                                <img src= {dotzBg}  uk-scrollspy="cls: uk-animation-slide-bottom; repeat: true"/>
                            </div>
                        </div>

    </div>


    </div>


        </div>

    </div>
)


export default Third_Pane;